import { RouterProvider } from '@tanstack/react-router';
import { ErrorBoundary } from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrightyThemeProvider, brightyTheme, nodaTheme, wolfoTheme } from '@razz-team/ui-web';
import { router } from './router';
import { AuthProvider, useApi } from './contexts/ApiContext';
import { queryClient } from './queries/queryClient';
import { useThemeMode } from './hooks/useThemeMode';
import { StrictMode } from 'react';
import { MaybeIntercomProvider } from './components/Intercom/MaybeIntercomProvider';

function RouterWithContext() {
  const api = useApi();
  return <RouterProvider router={router} context={{ api }} />;
}

export function App({ apiUrl }: { apiUrl: string }) {
  const themeMode = useThemeMode();

  return (
    <ErrorBoundary>
      <MaybeIntercomProvider appId={__INTERCOM_APP_ID__} autoBoot>
        <QueryClientProvider client={queryClient}>
          <AuthProvider baseUrl={apiUrl}>
            <StrictMode>
              <BrightyThemeProvider
                mode={themeMode}
                options={__NODA__ ? nodaTheme : __WOLFO__ ? wolfoTheme : brightyTheme}
              >
                <RouterWithContext />
              </BrightyThemeProvider>
            </StrictMode>
          </AuthProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MaybeIntercomProvider>
    </ErrorBoundary>
  );
}
